<ng-content></ng-content>
<div class="footer-actions">
    @for (action of actions; track action) {
        <button
            kui-button
            [tabIndex]="(action.keypress || '').toString() === '27' ? -1 : undefined"
            [color]="action.style || 'primary'"
            (click)="!action.disabled && buttonClicked.emit(action)"
            [class.disabled]="action.disabled"
            [disabled]="action.disabled || null"
            [style.pointer-events]="action.disabled ? 'none' : null"
        >
            @if (action.icon) {
                <kui-icon [name]="action.icon" size="sm" [class.d-sm-none]="action.hideIconOnDesktop" [class.mr-2]="!action.hideTextOnMobile"></kui-icon>
            }
            @if (action.text) {
                <span [class.d-none]="action.hideTextOnMobile" class="d-sm-inline-block">{{ action.text }} </span>
            }
        </button>
    }
</div>
